<div class="privacy-policy">
    <h1>Privacy Policy</h1>
    <p>
        Your privacy is critically important to us. This Privacy Policy explains how
        <strong>Assistive Musician Management and Schedule Alignment Service (AMMSAS)</strong> collects, uses, and
        protects your personal information in compliance with the EU General Data Protection Regulation (GDPR).
    </p>

    <h2>1. Data Controller</h2>
    <p>
        AMMSAS acts as the data controller for any personal information you provide while using our services. If you
        have any questions about this policy, please contact us:
        <br><strong>Email:</strong> info&#64;in-somnia.com
    </p>

    <h2>2. Data We Collect</h2>
    <p>
        We collect and process the following personal data:
    </p>
    <ul>
        <li>
            <strong>Account Information:</strong> Name, email address, phone number, and password.
        </li>
        <li>
            <strong>Usage Data:</strong> Information about your interactions with our platform, including IP address,
            browser type, and log data.
        </li>
        <li>
            <strong>Optional Data:</strong> Any additional information you provide (e.g., profile details, preferences).
        </li>
    </ul>

    <h2>3. How We Use Your Data</h2>
    <p>
        We use your personal data for the following purposes:
    </p>
    <ul>
        <li>To provide and improve our services.</li>
        <li>To communicate with you, including sending notifications and updates.</li>
        <li>To comply with legal obligations.</li>
        <li>To ensure the security and integrity of our platform.</li>
    </ul>

    <h2>4. Legal Basis for Processing</h2>
    <p>
        We process your personal data based on the following legal grounds:
    </p>
    <ul>
        <li>To fulfill our contractual obligations.</li>
        <li>With your explicit consent.</li>
        <li>To comply with legal obligations.</li>
        <li>For legitimate interests, such as improving our platform and ensuring its security.</li>
    </ul>

    <h2>5. Data Sharing</h2>
    <p>
        We do not sell your personal data to third parties. However, we may share your data with:
    </p>
    <ul>
        <li>Service providers who process data on our behalf (e.g., hosting providers).</li>
        <li>Authorities, if required by law or to protect our legal rights.</li>
    </ul>

    <h2>6. Data Retention</h2>
    <p>
        We retain your personal data only as long as necessary for the purposes outlined in this policy or as required
        by law.
    </p>

    <h2>7. Your Rights</h2>
    <p>
        Under GDPR, you have the following rights:
    </p>
    <ul>
        <li>The right to access your personal data.</li>
        <li>The right to rectify inaccuracies in your data.</li>
        <li>The right to request data deletion ("right to be forgotten").</li>
        <li>The right to restrict data processing.</li>
        <li>The right to data portability.</li>
        <li>The right to object to data processing.</li>
        <li>The right to withdraw consent at any time.</li>
        <li>The right to lodge a complaint with a supervisory authority.</li>
    </ul>

    <h2>8. Security</h2>
    <p>
        We implement technical and organizational measures to protect your data from unauthorized access, disclosure,
        alteration, and destruction.
    </p>

    <h2>9. Cookies</h2>
    <p>
        Our platform does not use Cookies to collect personal data.
    </p>

    <h2>10. Changes to This Policy</h2>
    <p>
        We may update this Privacy Policy periodically. Changes will be posted on this page, and significant updates
        will be communicated to you directly.
    </p>

    <h2>11. Contact Information</h2>
    <p>
        For questions or concerns about this Privacy Policy, please contact us:
        <br><strong>Email:</strong> info&#64;in-somnia.com
    </p>

    <h1>Datenschutzerklärung</h1>
    <p>
        Der Schutz Ihrer Daten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung erläutert, wie
        <strong>Assistive Musician Management and Schedule Alignment Service (AMMSAS)</strong> Ihre persönlichen Daten
        im Einklang mit der EU-Datenschutz-Grundverordnung (DSGVO) erhebt, verwendet und schützt.
    </p>

    <h2>1. Verantwortlicher</h2>
    <p>
        AMMSAS ist für die Verarbeitung Ihrer persönlichen Daten verantwortlich. Bei Fragen zu dieser
        Datenschutzerklärung können Sie uns kontaktieren:
        <br><strong>E-Mail:</strong> info&#64;in-somnia.com
    </p>

    <h2>2. Daten, die wir erheben</h2>
    <p>
        Wir erheben und verarbeiten folgende persönliche Daten:
    </p>
    <ul>
        <li>
            <strong>Kontoinformationen:</strong> Name, E-Mail-Adresse, Telefonnummer und Passwort.
        </li>
        <li>
            <strong>Nutzungsdaten:</strong> Informationen über Ihre Interaktionen mit unserer Plattform, einschließlich
            IP-Adresse, Browsertyp und Protokolldaten.
        </li>
        <li>
            <strong>Optionale Daten:</strong> Alle weiteren Informationen, die Sie bereitstellen (z. B. Profilangaben,
            Präferenzen).
        </li>
    </ul>

    <h2>3. Wie wir Ihre Daten nutzen</h2>
    <p>
        Wir verwenden Ihre persönlichen Daten für folgende Zwecke:
    </p>
    <ul>
        <li>Bereitstellung und Verbesserung unserer Dienste.</li>
        <li>Kommunikation mit Ihnen, einschließlich Benachrichtigungen und Updates.</li>
        <li>Erfüllung gesetzlicher Verpflichtungen.</li>
        <li>Gewährleistung der Sicherheit und Integrität unserer Plattform.</li>
    </ul>

    <h2>4. Rechtsgrundlage der Verarbeitung</h2>
    <p>
        Wir verarbeiten Ihre persönlichen Daten auf Grundlage folgender Rechtsgrundlagen:
    </p>
    <ul>
        <li>Erfüllung unserer vertraglichen Verpflichtungen.</li>
        <li>Mit Ihrer ausdrücklichen Einwilligung.</li>
        <li>Zur Erfüllung gesetzlicher Verpflichtungen.</li>
        <li>Zur Wahrung berechtigter Interessen, wie der Verbesserung unserer Plattform und der Gewährleistung ihrer
            Sicherheit.
        </li>
    </ul>

    <h2>5. Weitergabe von Daten</h2>
    <p>
        Wir verkaufen Ihre persönlichen Daten nicht an Dritte. Wir können Ihre Daten jedoch mit folgenden Parteien
        teilen:
    </p>
    <ul>
        <li>Dienstleistern, die Daten in unserem Auftrag verarbeiten (z. B. Hosting-Anbieter).</li>
        <li>Behörden, wenn dies gesetzlich vorgeschrieben ist oder um unsere Rechte zu schützen.</li>
    </ul>

    <h2>6. Speicherdauer</h2>
    <p>
        Wir speichern Ihre persönlichen Daten nur so lange, wie dies für die in dieser Erklärung beschriebenen Zwecke
        oder gesetzlich erforderlich ist.
    </p>

    <h2>7. Ihre Rechte</h2>
    <p>
        Nach der DSGVO haben Sie folgende Rechte:
    </p>
    <ul>
        <li>Recht auf Auskunft über Ihre persönlichen Daten.</li>
        <li>Recht auf Berichtigung unrichtiger Daten.</li>
        <li>Recht auf Löschung Ihrer Daten ("Recht auf Vergessenwerden").</li>
        <li>Recht auf Einschränkung der Verarbeitung.</li>
        <li>Recht auf Datenübertragbarkeit.</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung.</li>
        <li>Recht auf Widerruf Ihrer Einwilligung jederzeit.</li>
        <li>Recht auf Beschwerde bei einer Aufsichtsbehörde.</li>
    </ul>

    <h2>8. Sicherheit</h2>
    <p>
        Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor unbefugtem Zugriff, Offenlegung,
        Veränderung und Zerstörung zu schützen.
    </p>

    <h2>9. Cookies</h2>
    <p>
        Unsere Plattform verwendet keine Cookies.
    </p>

    <h2>10. Änderungen dieser Datenschutzerklärung</h2>
    <p>
        Wir können diese Datenschutzerklärung gelegentlich aktualisieren. Änderungen werden auf dieser Seite
        veröffentlicht, und wesentliche Aktualisierungen werden Ihnen direkt mitgeteilt.
    </p>

    <h2>11. Kontaktinformationen</h2>
    <p>
        Bei Fragen oder Bedenken zu dieser Datenschutzerklärung können Sie uns kontaktieren:
        <br><strong>E-Mail:</strong> info&#64;in-somnia.com
    </p>
</div>

<style>
    .privacy-policy {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        color: #333;
        max-width: 800px;
        margin: auto;
        padding: 20px;
        border: 1px solid #ccc;
        border-radius: 8px;
        background-color: #f9f9f9;
    }

    .privacy-policy h1 {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .privacy-policy h2 {
        font-size: 18px;
        margin-top: 20px;
        color: #0056b3;
    }

    .privacy-policy ul {
        margin: 10px 0;
        padding-left: 20px;
    }

    .privacy-policy li {
        margin-bottom: 8px;
    }

    .privacy-policy a {
        color: #0056b3;
        text-decoration: none;
    }

    .privacy-policy a:hover {
        text-decoration: underline;
    }
</style>